import { render, staticRenderFns } from "./doctorHomePage.vue?vue&type=template&id=25df0192"
import script from "./doctorHomePage.vue?vue&type=script&lang=js"
export * from "./doctorHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports